import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 18l.01 0","key":"svg-0"}],["path",{"d":"M9.172 15.172a4 4 0 0 1 5.656 0","key":"svg-1"}]]

/**
 * IconWifi1
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItd2lmaS0xIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMiAxOGwuMDEgMCIgLz4KICA8cGF0aCBkPSJNOS4xNzIgMTUuMTcyYTQgNCAwIDAgMSA1LjY1NiAwIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/wifi-1
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconWifi1 = createReactComponent('outline', 'wifi-1', 'Wifi1', __iconNode);

export default IconWifi1;